// <copy-button value="..."> — click-to-copy for Ui::CopyField. Same contract
// as the chart elements: the server renders the markup, the element only adds
// behaviour. The trigger button carries data-copy-trigger; its label span
// (data-copy-label) flips to "Copied" for a beat as the confirmation.
//
//   <copy-button value="https://winfred.uk/feeds/abc.rss">
//     <input readonly value="...">
//     <button data-copy-trigger><span data-copy-label>Copy</span></button>
//   </copy-button>

class CopyButton extends HTMLElement {
	#timer: ReturnType<typeof setTimeout> | undefined;

	connectedCallback() {
		this.querySelector<HTMLButtonElement>(
			"[data-copy-trigger]",
		)?.addEventListener("click", () => this.#copy());
	}

	async #copy() {
		const value = this.getAttribute("value") ?? "";
		try {
			await navigator.clipboard.writeText(value);
			this.#flash("Copied");
		} catch {
			// Clipboard API refused (permissions, insecure context): select the
			// input so a manual ⌘C still works.
			this.querySelector("input")?.select();
		}
	}

	#flash(text: string) {
		const label = this.querySelector<HTMLElement>("[data-copy-label]");
		if (!label) return;
		const original = label.textContent;
		label.textContent = text;
		clearTimeout(this.#timer);
		this.#timer = setTimeout(() => {
			label.textContent = original;
		}, 1600);
	}
}

if (!customElements.get("copy-button")) {
	customElements.define("copy-button", CopyButton);
}
